// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-AddressBook__addressItemsContainer__root"};